export enum AccountantDetailRequestType {
  receipt = 'receipt'
}
